<template>
  <div class="flex flex-col py-4">
    <div class>
      <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400">
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-2 py-2 w-3/6 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >MBI/NEN NGARKESE NESER:</th>
              <th
                class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >RIORGANIZIMI</th>
              <th
                class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >PO/JO</th>
              <th class="px-2 py-2 w-4 border border-gray-400 bg-gray-50"></th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-for="overload in overloads" :key="overload.id">
              <td class="border border-gray-400">
                {{ overload.comment }}
              </td>
              <td class="border border-gray-400">
                {{ overload.riorganizimi }}
              </td>
              <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">{{ overload.status }}</td>
              <td class="px-2 py-2 font-semibold whitespace-no-wrap border-b border-gray-400">
                <router-link
                  v-if="!user"
                  :to="{ name: 'edit-overload-tomorrow', params: { id: overload.id } }"
                >
                  <span
                    class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                  >Ndrysho</span>
                </router-link>
                <span class="ml-2">
                  <button
                    @click="deleteOverLoad(overload.id)"
                    class="text-indigo-600 font-semibold hover:text-indigo-900 focus:outline-none focus:underline"
                  >Fshije</button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    date: String,
    user: Number
  },
  data() {
    return {
      overloads: []
    };
  },
  computed: {
    getDate() {
      return this.date;
    }
  },
  watch: {
    date: function() {
      this.getOverLoadToday();
    },
    user: function() {
      this.getOverLoadToday();
    }
  },
  created() {
    this.getOverLoadToday();
  },
  methods: {
    getOverLoadToday() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (this.user) {
        axios
          .get(
            `${process.env.VUE_APP_API}/excel/ngarkesat?day=${this.date}&user_id=${this.user}`
          )
          .then(response => {
            this.overloads = response.data.ngarkesat_neser;
            // console.log(response);
          })
          .catch(error => console.log(error));
      } else {
        axios
          .get(`${process.env.VUE_APP_API}/excel/ngarkesat?day=${this.date}`)
          .then(response => {
            this.overloads = response.data.ngarkesat_neser;
            // console.log(response);
          })
          .catch(error => console.log(error));
      }
    },
    deleteOverLoad(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (confirm("A jeni i sigurt qe deshironi ta fshini?")) {
        axios
          .delete(`${process.env.VUE_APP_API}/excel/ngarkesat/${id}`)
          .then(() => {
            this.$notify({
              group: "address",
              title: "Mbi/Nen Ngarkesa",
              text: "Mbi/Nen Ngarkesa u fshi"
            });

            const index = this.overloads.findIndex(
              overload => overload.id === id
            );
            if (~index) this.overloads.splice(index, 1);
          })
          .catch(error => console.log(error));
      }
      // console.log("delete");
    }
  }
};
</script>

<style>
</style>